import { render, staticRenderFns } from "./misDocumentos.vue?vue&type=template&id=1d3dc4d3&"
import script from "./misDocumentos.vue?vue&type=script&lang=js&"
export * from "./misDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports